export default 'icon--quote';